export type Dimension = 'koncentrace' | 'atmosfera' | 'vztahy' | 'emoce';

export const DIMENSIONS: Dimension[] = ['koncentrace', 'atmosfera', 'vztahy', 'emoce'];

export const DIMENSION_LABELS: Record<Dimension, string> = {
    koncentrace: 'Koncentrace',
    atmosfera: 'Atmosféra',
    vztahy: 'Vztahy',
    emoce: 'Emoce',
};

/** theme_key z API: `{phase}.{primary}` → lidský název týdenního tématu */
export const THEME_LABELS: Record<string, string> = {
    'zaklad.koncentrace': 'Základ · Koncentrace',
    'zaklad.atmosfera': 'Základ · Atmosféra',
    'zaklad.vztahy': 'Základ · Vztahy',
    'zaklad.emoce': 'Základ · Emoce',
    'jadro.koncentrace': 'Jádro · Koncentrace',
    'jadro.atmosfera': 'Jádro · Atmosféra',
    'jadro.vztahy': 'Jádro · Vztahy',
    'jadro.emoce': 'Jádro · Emoce',
    'upevneni.koncentrace': 'Upevnění · Koncentrace',
    'upevneni.atmosfera': 'Upevnění · Atmosféra',
    'upevneni.vztahy': 'Upevnění · Vztahy',
    'upevneni.emoce': 'Upevnění · Emoce',
};

export function themeLabel(themeKey: string | null): string {
    if (!themeKey) return 'Další téma';
    return THEME_LABELS[themeKey] ?? themeKey;
}

export type AnswerValue =
    | 'souhlasim_naprosto'
    | 'souhlasim_spise'
    | 'nejsem_si_jisty'
    | 'nesouhlasim_spise'
    | 'nesouhlasim_naprosto';

export type AgeBand = '1_3' | '4_5';

export type PlanAnswers = Record<string, AnswerValue>;

export interface PlanLecture {
    name: string;
    video: { url: string; poster: string; length: number };
    methodology: string | null;
}

export interface PlanDay {
    position: number;
    exercise_id: string;
    is_anchor: boolean;
    why_key: string;
    is_completed: boolean;
    is_current: boolean;
    lecture: PlanLecture | null;
}

export interface PlanWeek {
    week: number;
    theme_key: string | null;
    locked: boolean;
    days: PlanDay[];
}

export interface PlanResponse {
    primary_dimension: Dimension;
    dimension_scores: Record<Dimension, number>;
    wellbeing: number;
    current_position: number;
    current_day_position: number | null;
    total_positions: number;
    completed_positions: number;
    is_complete: boolean;
    weeks: PlanWeek[];
}
